import React, { useState, useEffect, act } from 'react';
import CandidateSearch from './candidateSearch';
import CandidateList from './candidateList';
import Navbar from '../../../common/navbar';
import MatchingCandidatesList from '../matchingCandidates/matchingCandidatesList';
import CandidateDetailPage from './candidateDetailPage';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';
import Loader from '../../../common/loader';
import { RecruiterApi } from '../../../supports/recruiterApi';
import { generateRequestId } from '../../../common/common';
import unifiedAuthManager from '../../../services/unifiedAuthManager';
const Breadcrumb = ({ candidateName, onBack, query, searchType }) => (
  <div className="flex items-center gap-2 text-sm text-gray-666 mb-5">
    <button
      onClick={onBack}
      className="hover:underline text-inherit bg-transparent cursor-pointer p-0 border-0"
      style={{ appearance: 'none' }}
      tabIndex={0}
    >
      Candidates
    </button>
    <FiChevronRight size={14} />
    <span className="font-semibold mph-primary">{candidateName}</span>
  </div>
);

const CandidatesPage = () => {
  const [candidates, setCandidates] = useState();
  const [searchQuery, setSearchQuery] = useState('');
  const [searchType, setSearchType] = useState('description'); // default to 'description'
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [matchingCandidates, setMatchingCandidates] = useState([]);
  const [activeTab, setActiveTab] = useState('New');
  const [isTyping, setIsTyping] = useState(false);
  const [jobDetails, setJobDetails] = useState(null);
  const user = unifiedAuthManager.getUnifiedUser();
  const location = useLocation();
  const navigate = useNavigate();
  const [filterData, setFilterData] = useState([]);
  const [hasMoreCandidates, setHasMoreCandidates] = useState(false);

  useEffect(() => {
    if (location.pathname !== '/candidates') return;
    const navEntries = performance.getEntriesByType('navigation');
    const navType = navEntries[0]?.type;
    if (location.search && (navType === 'reload' || navType === 'back_forward')) {
      navigate('/candidates', { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  const handleCandidatesFound = (foundCandidates) => {
    setCandidates(foundCandidates);
    if (foundCandidates) {
      setSearchType(foundCandidates.searchType);
      setSearchQuery(foundCandidates.query?.title);
      if (foundCandidates.candidates) {
        setMatchingCandidates(foundCandidates.candidates);
        if (foundCandidates?.query?.id) {
          fetchJobDetails(foundCandidates?.query?.mph_jobid);
        }
      }
    }
  };

  const handleLoadMoreSearch = async (pageNum) => {
    try {

      console.log("filterData in handleLoadMoreSearch:", filterData);
      const response = await RecruiterApi.searchCandidates({
        page: pageNum,
        count: 50, // PAGE_SIZE
        user_payload: { request_id: generateRequestId(), email: user?.email, user_id: user?.id },
        search_text: searchQuery,
        active_filters: filterData,
      });
      console.log("response handleLoadMoreSearch:", response);
      if (response && response.success && Array.isArray(response.data?.candidates)) {
        setHasMoreCandidates(response.data.has_more);
        return response.data.candidates;
      }
      return [];
    } catch (err) {
      return [];
    }
  };
const handleCandidateUpdate = (updatedCandidate) => {
    try {
      
      setCandidates((prevCandidates) => {
        if (!prevCandidates || !Array.isArray(prevCandidates.candidates)) {
          return prevCandidates;
        }

        const updatedCandidates = prevCandidates.candidates.map((candidate) =>
          candidate.id === updatedCandidate.id ? updatedCandidate : candidate
        );

        return { ...prevCandidates, candidates: updatedCandidates };
      });
    } catch (error) {
      console.error("Error updating candidate:", error);
    }
  };


  const fetchJobDetails = async (id) => {
    try {
      const response = await RecruiterApi.getJobDetails({
        job_id: id,
        user_payload: { request_id: generateRequestId() },
        email: user.email,
      });

      if (response.success) {
        setJobDetails(response.data);
      } else {
        setJobDetails(null);
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
      setJobDetails(null);
    }
  };

  const handleCandidateClick = (candidate) => {
    setSelectedCandidate(candidate);
  };

  const setNewFilterValue =(value)=>{
    try {
      console.log("New filter value from CandidatesPage:", value);
      setFilterData(value);
    } catch (error) {
      console.error("Error setting new filter value:", error);
    }
  }

  const onMatchingCandidateClick = (candidate, currentCandidateList) => {
    setSelectedCandidate(candidate);
    if (Array.isArray(currentCandidateList)) {
      setMatchingCandidates(currentCandidateList);
    } else {
      setActiveTab(currentCandidateList);
    }
    let searchedJobFormatted = "";
    let jobId = "";
    if (candidates && candidates.query) {
      const { title, mph_jobid, id } = candidates.query;
      if (title && mph_jobid) {
        searchedJobFormatted = `${title} (${mph_jobid})`;
      } else if (title) {
        searchedJobFormatted = title;
      }
      if (id) {
        jobId = id;
      }
    }
    const params = new URLSearchParams();
    if (jobId) params.append('jobId', jobId);
    if (searchedJobFormatted) params.append('query', searchedJobFormatted);
    params.append('type', 'dropdown');
    const search = params.toString() ? `?${params.toString()}` : '';

    navigate(`/candidates/${candidate.id}${search}`);
  };

  const handleBackToCandidates = () => {
    setSelectedCandidate(null);
    navigate('/candidates', { replace: true });
  };

  // Show candidate detail page when a candidate is selected
  if (selectedCandidate) {
    return (
      <div className="min-h-screen bg-white relative main-background pt-28">
        <Navbar />
        <main className="w-full px-4 overflow-hidden">
          <Breadcrumb
            candidateName={selectedCandidate?.full_name ?? `${selectedCandidate.first_name || ""} ${selectedCandidate.last_name || ""}`}
            onBack={handleBackToCandidates}
            query={searchQuery}
            searchType={searchType}
          />
          <div className="mx-auto px-3 pb-8">
            <CandidateDetailPage
              candidate={selectedCandidate}
              similarCandidates={matchingCandidates}
              pageType="matching"
              onViewAll={handleBackToCandidates}
              onCandidateChange={handleCandidateClick}
              jobId={candidates.query.id}
              llmScore={selectedCandidate.llm_score}
              jobMphId={candidates.query.mph_jobid}
              jobDetails={jobDetails}
            />
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen main-background flex flex-col">
      <Navbar />
      <div className="pt-24 w-full flex-1 flex flex-col">
        <header className="text-left px-8 mb-4">
          <div className="text-md font-bold mph-primary">Candidates</div>
        </header>
        <div className="flex-1 grid grid-cols-1 lg:grid-cols-3 gap-4 px-8 pb-8 items-start min-h-0">
          <div className={`h-[calc(100vh-9rem)] min-h-0 transition-all duration-300 ${isTyping ? 'lg:col-span-2' : 'lg:col-span-1'} anim-slideRight`} style={{ animationDuration: "1.5s" }}>
            <div className="h-full overflow-y-auto bg-white shadow-sm rounded-2xl">
              <CandidateSearch onCandidatesFound={handleCandidatesFound} onTypingStateChange={setIsTyping} sendFilterData={setNewFilterValue} />
            </div>
          </div>
          <div className={`h-[calc(100vh-9rem)] min-h-0 transition-all duration-300 ${isTyping ? 'lg:col-span-1' : 'lg:col-span-2'} anim-slideLeft`} style={{ animationDuration: "1.5s" }}>
            <div className="h-full max-h-[calc(100vh-8rem)] overflow-y-auto">
              {candidates && !candidates.loading ? (
                searchType === 'dropdown' ? (
                  <MatchingCandidatesList
                    pageType="matching"
                    candidates={candidates?.candidates}
                    query={searchQuery}
                    searchType={searchType}
                    onMatchingCandidateClick={onMatchingCandidateClick}
                    mph_jobid={candidates.query.mph_jobid}
                    job_id={candidates.query.id}
                    candidateActiveTab={activeTab}
                    jobDetails={jobDetails}
                  />
                ) : (
                  
                  <CandidateList
                    candidates={candidates}
                    pageType="standard"
                    query={searchQuery}
                    searchType={searchType}
                    isTyping = {isTyping}
                    onLoadMore={handleLoadMoreSearch}
                    onCandidateUpdateFilter={handleCandidateUpdate}
                    searchHasMore={hasMoreCandidates}
                    setSearchHasMore={setHasMoreCandidates}
                  />
                )
              ) : (
                <div className="flex justify-center items-center h-full">
                  <Loader />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidatesPage;